import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { Chip } from '@spotahome/ui-library';

import { getCarouselIconToDisplay } from './utils/getSliderComponent';

import './CarouselItem.scss';

const CarouselItem = ({ type, isSelected, handleTrackClick, isFullScreen }) => {
  const Icon = getCarouselIconToDisplay(type);

  return (
    <Chip.Choice
      isDarkMode={isFullScreen}
      isActivated={isSelected}
      onClick={handleTrackClick}
      className="carousel-item"
      label={trans(`slider.carousel.${type}`)}
      renderLeadingIcon={
        Icon
          ? () => (
              <Icon
                theme={
                  isFullScreen && !isSelected ? 'light' : 'interactionDark'
                }
              />
            )
          : null
      }
    />
  );
};

CarouselItem.propTypes = {
  type: PropTypes.oneOf(['img', 'plan', 'video', 'map', 'viewer360'])
    .isRequired,
  isFullScreen: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleTrackClick: PropTypes.func.isRequired
};

export default CarouselItem;
